// AboutPage.jsx
import React from "react";
import { Link } from "react-router-dom";
import founderPhoto from "./assets/venkata-martha.jpg";

export function AboutPage() {
  return (
    <main className="about-page">
      <section className="about-hero page-shell">
        <p className="eyebrow">ABOUT NORI</p>
        <h1>What if the relationship<br />kept going?</h1>
        <p>Nori is building the software businesses need to create a useful, manageable community around the customer relationship they already own.</p>
      </section>
      <section className="mission-band">
        <div className="page-shell mission-grid">
          <p className="eyebrow">OUR MISSION</p>
          <div><h2>Make the moments after a purchase matter.</h2><p>We believe a transaction can be the start of a better relationship. Nori gives businesses a place for customers to share useful stories, discover what is next, and take part in a community the business can thoughtfully run.</p></div>
        </div>
      </section>
      <section className="about-principle">
        <div className="page-shell about-principle-grid">
          <p className="eyebrow">THE PROBLEM</p>
          <div><h2>Customers want connection.<br /><em>Businesses need a place to host it.</em></h2><p>Ads and creator posts compete in broad social feeds. Messaging groups can bring customers together, but are difficult to operate as a consistent customer experience. Nori is designed to give businesses a branded destination and the workflow to manage it.</p></div>
        </div>
      </section>
      <section className="about-page-section page-shell">
        <p className="eyebrow">WHAT NORI IS TESTING</p>
        <div className="about-points">
          <article><span>01</span><h3>A business-owned home</h3><p>Content feeds and lightweight branded experiences that can work alongside an existing customer app.</p></article>
          <article><span>02</span><h3>Tools for the team</h3><p>Upload, moderation, rewards, and event workflows designed to make community operations practical.</p></article>
          <article><span>03</span><h3>A measurable return loop</h3><p>Product and loyalty connections could help test whether participation contributes to incremental repeat behavior.</p></article>
        </div>
      </section>
      <section className="about-hypothesis">
        <div className="page-shell about-hypothesis-grid">
          <div><p className="eyebrow">A MOAT HYPOTHESIS, NOT A CLAIM</p><h2>Learn what helps customers return.</h2></div>
          <div><p>Nori's long-term opportunity is to understand which content, rewards, creators, and events are associated with repeat purchases and visits. That advantage does not yet exist as demonstrated evidence.</p><p>It depends on adoption, working integrations, customer consent, clear data rights, and measurement that separates correlation from incremental impact. A pilot should also account for reward and moderation costs.</p></div>
        </div>
      </section>
      <section className="about-page-section page-shell about-founder-row">
        <img className="about-founder-photo" src={founderPhoto} alt="Venkata Martha, founder of Nori" width="720" height="853" loading="lazy" />
        <div>
          <p className="eyebrow">THE TEAM</p>
          <h2>Built by a team of three engineers.</h2>
          <p>Founder Venkata Martha is building Nori with a small engineering team. The next step is to turn the current beta workflows into a packaged product with design partners.</p>
          <Link className="text-link" to="/team">Meet the team</Link>
        </div>
      </section>
      <section className="about-cta">
        <div className="page-shell about-cta-inner"><div><p className="eyebrow">EARLY STAGE, CLEAR NEXT STEPS</p><h2>SDK v1. Two design partners.<br /><em>One measured pilot.</em></h2></div><a className="button button-primary" href="/#pricing">See pricing <span aria-hidden="true">↗</span></a></div>
      </section>
    </main>
  );
}
